import { bool, params, shape, string, } from '@thd-nucleus/data-sources';

export const dataModel = {
  serviceAddOns: params({ itemId: string().isRequired(),
    storeId: string().isRequired() }).shape({
    sellFurnishInstall: shape({
      installationProgramCategory: string(),
      dualPathSku: bool()
    })
  })
};
